export const resolveInterestRate = interestRate =>
  interestRate?.rate ?? interestRate?.interestRate ?? null;

export const resolveApr = interestRate =>
  interestRate?.apr ?? interestRate?.annualPercentageRate ?? null;

export const resolveMonthlyPayment = metrics =>
  metrics?.monthlyPayment ?? metrics?.principalAndInterest ?? null;
